<template>
  <el-dialog
    :visible.sync="showSdrLoginDialog"
    :destroy-on-close="true"
    :before-close="closeSdrLoginDialog"
    width="380px"
    :append-to-body="true"
    class="wap"
    >
    <div style="width:90%;padding:20px">
    <el-input v-model="sdrLoginForm.email" placeholder="email" auto-complete="new-password" style="margin-top: 20px;"></el-input>
<!--    <el-input v-model="sdrLoginForm.sdr" placeholder="sdr" auto-complete="new-password" style="margin:20px 0px"></el-input>-->
    <el-input v-model="sdrLoginForm.password" placeholder="password" auto-complete="new-password" :type="passw" style="margin:20px 0;">
        <i slot="suffix" @click="showPass">
        <img
            v-if="passw=='password'"
            style="width:25px;height:25px"
            src="../../assets/img/icon-hide.png"
            alt="" />
        <img
            v-else
            style="width:25px;height:25px"
            src="../../assets/img/icon-show.png"
            alt="" />
        </i>
    </el-input>
    <el-button @click="sdrLogin">Login</el-button>
    </div>
</el-dialog>
</template>

<script>
export default {
  props: {
    showSdrLoginDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      passw: 'password',
      sdrLoginForm: {
        email: '',
        sdr: '',
        password: ''
      }

    }
  },
  methods: {
    closeSdrLoginDialog() {
      this.$emit('closeSdrLoginDialog')
    },
    sdrLogin() {
      // 登录参数准备
      this.$emit('sdrLogin', this.sdrLoginForm)
    },
    showPass() {
      // 点击图标是密码隐藏或显示
      if (this.passw === 'text') {
        this.passw = 'password'
      } else {
        this.passw = 'text'
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/components/sdr-login.vue